import React from 'react';

import { IOption } from './Select';
import { ItemList } from './styles';
import SelectOptionItem from './SelectOptionItem';

interface IComponentProps {
  selectionIndicator: boolean;
  multiChoice: boolean;
  pointer: number;
  inPopOver?: boolean;
  options: IOption[];
  values: IOption[];
  expanded: Set<string | number>;
  expandable: Set<string | number>;
  expand: (value: string | number) => void;
  onUpdatePointer: (
    index: number
  ) => (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
  onSelectAOption: (
    option: IOption
  ) => (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void;
}

class SelectOptions extends React.PureComponent<IComponentProps> {
  render() {
    const {
      pointer,
      options,
      onUpdatePointer,
      onSelectAOption,
      expand,
      expanded,
      expandable,
      values,
      selectionIndicator,
      multiChoice,
      inPopOver,
    } = this.props;
    return (
      <ItemList inPopover={inPopOver}>
        {this.getItemList(
          undefined,
          options,
          pointer,
          onUpdatePointer,
          onSelectAOption,
          expandable,
          expanded,
          expand,
          values,
          0,
          selectionIndicator,
          multiChoice
        )}
      </ItemList>
    );
  }

  getItemList(
    parentValue: undefined | number | string,
    options: IOption[],
    pointer: number,
    onUpdatePointer: (
      index: number
    ) => (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void,
    onSelectAOption: (
      option: IOption
    ) => (e: React.MouseEvent<HTMLLIElement, MouseEvent>) => void,
    expandable: Set<string | number>,
    expanded: Set<string | number>,
    expand: (value: string | number, expanded: boolean) => void,
    values: IOption[],
    depth: number,
    selectionIndicator: boolean,
    multiChoice: boolean
  ): any {
    const inTree = expandable.size > 0;
    const ret: any[] = [];
    options.forEach((item, index) => {
      if ((item.parent ?? undefined) !== (parentValue ?? undefined)) return;
      const itemExpanded = expanded.has(item.value);
      const exist = !!values?.find((it) => it.value === item.value);
      ret.push(
        <SelectOptionItem
          disabled={item.disabled}
          inTree={inTree}
          key={`${item.value}_index[${index}]`}
          label={item.label}
          value={item.value}
          isActive={pointer === index}
          onUpdatePointer={onUpdatePointer(index)}
          onSelectAOption={onSelectAOption(item)}
          expandable={expandable.has(item.value)}
          expanded={itemExpanded}
          expand={expand}
          depth={depth}
          selected={exist}
          selectionIndicator={selectionIndicator}
          multiChoice={multiChoice}
        />
      );

      if (itemExpanded)
        ret.push(
          ...this.getItemList(
            item.value,
            options,
            pointer,
            onUpdatePointer,
            onSelectAOption,
            expandable,
            expanded,
            expand,
            values,
            depth + 1,
            selectionIndicator,
            multiChoice
          )
        );
    });
    return ret;
  }
}

export default SelectOptions;
